if(document.querySelector('.swatch_options .swatch-element')){
  let swatchElement = document.querySelectorAll('.swatch_options .swatch-element');
  swatchElement.forEach(swatchButton => {
    swatchButton.addEventListener('click', () => {
      const buttonATC = document.querySelector('.purchase-details .purchase-details__spb--false');
      const textButtonATC = document.querySelector('.saving-freeship');
      const textNoOption = document.querySelector('.js-text');
      const textMatch = document.querySelector('.js-button-match');
      const textPrice = document.querySelector('.js-btn-price');
      const dataValue = swatchButton.getAttribute('data-value');
      const parentSwatch = swatchButton.parentElement;
      const labelParentSwatch = parentSwatch.querySelector('.js-option-title');
      const labelParentSwatchspan = labelParentSwatch.querySelector('.js-value');
      const labelParentSwatchspanSize = document.querySelector('.js-value.is-value-size');
      const labelParentSwatchspanColor = document.querySelector('.js-value.is-value-color');
      const labelParentSwatchspanBundle = document.querySelector('.js-value.is-value-bundle');
      labelParentSwatchspan.innerHTML = dataValue;
      labelParentSwatch.parentElement.setAttribute('size-value', dataValue);
      if(textMatch.style.display = 'none'){
        textMatch.style.display = 'inline-block';
      }
      if(textPrice.style.display = 'none'){
        textPrice.style.display = 'inline-block';
      }
      if(labelParentSwatchspanSize && labelParentSwatchspanColor && labelParentSwatchspanBundle){
        if(labelParentSwatchspanSize.innerHTML != "" && labelParentSwatchspanColor.innerHTML != "" && labelParentSwatchspanBundle.innerHTML != ""){
          buttonATC.classList.add('pointer-events');
          if(textButtonATC.style.display = 'none'){
            textButtonATC.style.display = 'block';
          }
          if(textNoOption.style.display = 'block'){
            textNoOption.style.display = 'none';
          }
        }
      }
    });
  });
}

if(document.querySelector('.js-variant-of-bundle')){
  const variantBundles = document.querySelectorAll('.js-variant-of-bundle');
  variantBundles.forEach((variantBundle) => {
    const valueTop = variantBundle.getAttribute('label-top');
    const valueBottom = variantBundle.getAttribute('label-bottom');
    const labelTop = document.createElement("label");
    const labelBottom = document.createElement("label");
    const contentlabelTop = document.createTextNode(valueTop);
    labelTop.appendChild(contentlabelTop);
    if(valueTop == ""){
      labelTop.classList.add('hidden');
    }else {
      labelTop.classList.add('label-top');
    }
    const contentlabelBottom = document.createTextNode(valueBottom);
    labelBottom.appendChild(contentlabelBottom);
    if(valueBottom == ""){
      labelBottom.classList.add('hidden');
    }else {
      labelBottom.classList.add('label-bottom');
    }
    variantBundle.appendChild(labelTop);
    variantBundle.appendChild(labelBottom);
  });
}

// if(document.querySelector('.is-bundle-1-pair')){
//   const bundle1pack = document.querySelector('.is-bundle-1-pair');
//   const value1Top = bundle1pack.getAttribute('label-top');
//   const value1Bottom = bundle1pack.getAttribute('label-bottom');
//   const label1Top = document.createElement("label");
//   const label1Bottom = document.createElement("label");
//   const contentlabel1Top = document.createTextNode(value1Top);
//   label1Top.appendChild(contentlabel1Top);
//   if(value1Top == ""){
//     label1Top.classList.add('hidden');
//   }else {
//     label1Top.classList.add('label-top');
//   }
//   const contentlabel1Bottom = document.createTextNode(value1Bottom);
//   label1Bottom.appendChild(contentlabel1Bottom);
//   if(value1Bottom == ""){
//     label1Bottom.classList.add('hidden');
//   }else {
//     label1Bottom.classList.add('label-bottom');
//   }
//   bundle1pack.appendChild(label1Top);
//   bundle1pack.appendChild(label1Bottom);
// }

// if(document.querySelector('.is-bundle-2-pack')){
//   const bundle2pack = document.querySelector('.is-bundle-2-pack');
//   const value2Top = bundle2pack.getAttribute('label-top');
//   const value2Bottom = bundle2pack.getAttribute('label-bottom');
//   const label2Top = document.createElement("label");
//   const label2Bottom = document.createElement("label");
//   const contentlabel2Top = document.createTextNode(value2Top);
//   label2Top.appendChild(contentlabel2Top);
//   if(value2Top == ""){
//     label2Top.classList.add('hidden');
//   }else {
//     label2Top.classList.add('label-top');
//   }
//   const contentlabel2Bottom = document.createTextNode(value2Bottom);
//   label2Bottom.appendChild(contentlabel2Bottom);
//   if(value2Bottom == ""){
//     label2Bottom.classList.add('hidden');
//   }else {
//     label2Bottom.classList.add('label-bottom');
//   }
//   bundle2pack.appendChild(label2Top);
//   bundle2pack.appendChild(label2Bottom);
// }

// if(document.querySelector('.is-bundle-3-pack')){
//   const bundle3pack = document.querySelector('.is-bundle-3-pack');
//   const value3Top = bundle3pack.getAttribute('label-top');
//   const value3Bottom = bundle3pack.getAttribute('label-bottom');
//   const label3Top = document.createElement("label");
//   const label3Bottom = document.createElement("label");
//   const contentlabel3Top = document.createTextNode(value3Top);
//   label3Top.appendChild(contentlabel3Top);
//   if(value3Top == ""){
//     label3Top.classList.add('hidden');
//   }else {
//     label3Top.classList.add('label-top');
//   }
//   const contentlabel3Bottom = document.createTextNode(value3Bottom);
//   label3Bottom.appendChild(contentlabel3Bottom);
//   if(value3Bottom == ""){
//     label3Bottom.classList.add('hidden');
//   }else {
//     label3Bottom.classList.add('label-bottom');
//   }
//   bundle3pack.appendChild(label3Top);
//   bundle3pack.appendChild(label3Bottom);
// }

// if(document.querySelector('.is-bundle-4-pack')){
//   const bundle4pack = document.querySelector('.is-bundle-4-pack');
//   const value4Top = bundle4pack.getAttribute('label-top');
//   const value4Bottom = bundle4pack.getAttribute('label-bottom');
//   const label4Top = document.createElement("label");
//   const label4Bottom = document.createElement("label");
//   const contentlabel4Top = document.createTextNode(value4Top);
//   label4Top.appendChild(contentlabel4Top);
//   if(value4Top == ""){
//     label4Top.classList.add('hidden');
//   }else {
//     label4Top.classList.add('label-top');
//   }
//   const contentlabel4Bottom = document.createTextNode(value4Bottom);
//   label4Bottom.appendChild(contentlabel4Bottom);
//   if(value4Bottom == ""){
//     label4Bottom.classList.add('hidden');
//   }else {
//     label4Bottom.classList.add('label-bottom');
//   }
//   bundle4pack.appendChild(label4Top);
//   bundle4pack.appendChild(label4Bottom);
// }

// if(document.querySelector('.is-bundle-5-pack')){
//   const bundle5pack = document.querySelector('.is-bundle-5-pack');
//   const value5Top = bundle5pack.getAttribute('label-top');
//   const value5Bottom = bundle5pack.getAttribute('label-bottom');
//   const label5Top = document.createElement("label");
//   const label5Bottom = document.createElement("label");
//   const contentlabel5Top = document.createTextNode(value5Top);
//   label5Top.appendChild(contentlabel5Top);
//   if(value5Top == ""){
//     label5Top.classList.add('hidden');
//   }else {
//     label5Top.classList.add('label-top');
//   }
//   const contentlabel5Bottom = document.createTextNode(value5Bottom);
//   label5Bottom.appendChild(contentlabel5Bottom);
//   if(value5Bottom == ""){
//     label5Bottom.classList.add('hidden');
//   }else {
//     label5Bottom.classList.add('label-bottom');
//   }
//   bundle5pack.appendChild(label5Top);
//   bundle5pack.appendChild(label5Bottom);
// }

// if(document.querySelector('.is-bundle-6-pack')){
//   const bundle6pack = document.querySelector('.is-bundle-6-pack');
//   const value6Top = bundle6pack.getAttribute('label-top');
//   const value6Bottom = bundle6pack.getAttribute('label-bottom');
//   const label6Top = document.createElement("label");
//   const label6Bottom = document.createElement("label");
//   const contentlabel6Top = document.createTextNode(value6Top);
//   label6Top.appendChild(contentlabel6Top);
//   if(value6Top == ""){
//     console.log(value6Top);
//     label6Top.classList.add('hidden');
//   }else {
//     console.log(value6Top);
//     label6Top.classList.add('label-top');
//   }
//   const contentlabel6Bottom = document.createTextNode(value6Bottom);
//   label6Bottom.appendChild(contentlabel6Bottom);
//   if(value6Bottom == ""){
//     label6Bottom.classList.add('hidden');
//   }else {
//     label6Bottom.classList.add('label-bottom');
//   }
//   bundle6pack.appendChild(label6Top);
//   bundle6pack.appendChild(label6Bottom);
// }


// size labels only for non-crew styles

document.addEventListener("DOMContentLoaded", function() {
    // Select the product title element (modify selector if needed)
    let productTitleElement = document.querySelector("title");
    const pageTitleText = productTitleElement ? productTitleElement.textContent : null;
    // Check if the page title does not include "crew" (case-insensitive)
    if (pageTitleText && !/crew/i.test(pageTitleText)) {
        if (document.querySelector('.is-size-small')) {
            const sizeSmall = document.querySelector('.is-size-small');
            const labelsmallBottom = document.createElement("label");

            // Set inner HTML with UK size details
            labelsmallBottom.innerHTML = "UK 3<span>&frac12;</span>-5<span>&frac12;</span>";

            // Add class for styling
            labelsmallBottom.classList.add('size-label-bottom');

            // Append the new label to the size small element
            sizeSmall.appendChild(labelsmallBottom);
        }
    }
});

//if(document.querySelector('.is-size-small')){
//  const sizeSmall = document.querySelector('.is-size-small');
//  const labelsmallBottom = document.createElement("label");
  // const contentlabelsmallBottom = document.createTextNode("UK 3-5.5");
//  labelsmallBottom.innerHTML += "UK 3<span>&frac12;</span>-5<span>&frac12;</span>";
  // labelsmallBottom.appendChild(contentlabelsmallBottom);
//  labelsmallBottom.classList.add('size-label-bottom');
//  sizeSmall.appendChild(labelsmallBottom);
//}


document.addEventListener("DOMContentLoaded", function() {
    // Select the product title element (modify selector if needed)
    let productTitleElement = document.querySelector("title");
    const pageTitleText = productTitleElement ? productTitleElement.textContent : null;
    // Check if the product title does not include "crew" (case-insensitive)
    if (pageTitleText && !/crew/i.test(pageTitleText)) {
        if (document.querySelector('.is-size-medium')) {
            const sizeMedium = document.querySelector('.is-size-medium');
            const labelmediumBottom = document.createElement("label");

            // Set inner HTML with UK size details
            labelmediumBottom.innerHTML = "UK 6-8";

            // Add class for styling
            labelmediumBottom.classList.add('size-label-bottom');

            // Append the new label to the size small element
            sizeMedium.appendChild(labelmediumBottom);
        }
    }
});

// if(document.querySelector('.is-size-medium')){
//  const sizeMedium = document.querySelector('.is-size-medium');
//  const labelmediumBottom = document.createElement("label");
  // const contentlabelmediumBottom = document.createTextNode("UK 6-8");
//  labelmediumBottom.innerHTML += "UK 6-8";
  // labelmediumBottom.appendChild(contentlabelmediumBottom);
//  labelmediumBottom.classList.add('size-label-bottom');
//  sizeMedium.appendChild(labelmediumBottom);
//}

document.addEventListener("DOMContentLoaded", function() {
    // Select the product title element (modify selector if needed)
    let productTitleElement = document.querySelector("title");
    const pageTitleText = productTitleElement ? productTitleElement.textContent : null;
    // Check if the product title does not include "crew" (case-insensitive)
    if (pageTitleText && !/crew/i.test(pageTitleText)) {
        if (document.querySelector('.is-size-large')) {
            const sizeLarge = document.querySelector('.is-size-large');
            const labellargeBottom = document.createElement("label");

            // Set inner HTML with UK size details
            labellargeBottom.innerHTML = "UK 8<span>&frac12;</span>-11";

            // Add class for styling
            labellargeBottom.classList.add('size-label-bottom');

            // Append the new label to the size small element
            sizeLarge.appendChild(labellargeBottom);
        }
    }
});

//if(document.querySelector('.is-size-large')){
//  const sizeLarge = document.querySelector('.is-size-large');
//  const labellargeBottom = document.createElement("label");
  // const contentlabellargeBottom = document.createTextNode("UK 8.5-11");
//  labellargeBottom.innerHTML += "UK 8<span>&frac12;</span>-11";
  // labellargeBottom.appendChild(contentlabellargeBottom);
//  labellargeBottom.classList.add('size-label-bottom');
//  sizeLarge.appendChild(labellargeBottom);
// }


// now for the size labels ONLY for Crew styles

document.addEventListener("DOMContentLoaded", function() {
    // Select the product title element (modify selector if needed)
    let productTitleElement = document.querySelector("title");
    const pageTitleText = productTitleElement ? productTitleElement.textContent : null;
    // Check if the page title does not include "crew" (case-insensitive)
    if (pageTitleText && /crew/i.test(pageTitleText)) {
        if (document.querySelector('.is-size-small')) {
            const sizeSmall = document.querySelector('.is-size-small');
            const labelsmallBottom = document.createElement("label");

            // Set inner HTML with UK size details
            labelsmallBottom.innerHTML = "UK 5-6<span>&frac12;</span>";

            // Add class for styling
            labelsmallBottom.classList.add('size-label-bottom');

            // Append the new label to the size small element
            sizeSmall.appendChild(labelsmallBottom);
        }
    }
});

document.addEventListener("DOMContentLoaded", function() {
    // Select the product title element (modify selector if needed)
    let productTitleElement = document.querySelector("title");
    const pageTitleText = productTitleElement ? productTitleElement.textContent : null;
    // Check if the product title does not include "crew" (case-insensitive)
    if (pageTitleText && /crew/i.test(pageTitleText)) {
        if (document.querySelector('.is-size-medium')) {
            const sizeMedium = document.querySelector('.is-size-medium');
            const labelmediumBottom = document.createElement("label");

            // Set inner HTML with UK size details
            labelmediumBottom.innerHTML = "UK 7-9<span>&frac12;</span>";

            // Add class for styling
            labelmediumBottom.classList.add('size-label-bottom');

            // Append the new label to the size small element
            sizeMedium.appendChild(labelmediumBottom);
        }
    }
});


document.addEventListener("DOMContentLoaded", function() {
    // Select the product title element (modify selector if needed)
    let productTitleElement = document.querySelector("title");
    const pageTitleText = productTitleElement ? productTitleElement.textContent : null;
    // Check if the product title does not include "crew" (case-insensitive)
    if (pageTitleText && /crew/i.test(pageTitleText)) {
        if (document.querySelector('.is-size-large')) {
            const sizeLarge = document.querySelector('.is-size-large');
            const labellargeBottom = document.createElement("label");

            // Set inner HTML with UK size details
            labellargeBottom.innerHTML = "UK 10-12";

            // Add class for styling
            labellargeBottom.classList.add('size-label-bottom');

            // Append the new label to the size small element
            sizeLarge.appendChild(labellargeBottom);
        }
    }
});





if(document.querySelector('.js-size-popup')){
  const btnOpenSize = document.querySelectorAll('.js-size-popup');
  btnOpenSize.forEach(btn => {
    btn.addEventListener('click', () => {
      const sizePopup = document.querySelector('.size-chart-popup');
      sizePopup.classList.add('open');
    });
  });
}

if(document.querySelector('.close-size-chart')){
  const btnCloseSize = document.querySelector('.close-size-chart');
  btnCloseSize.addEventListener('click', () => {
    const sizePopup = document.querySelector('.size-chart-popup');
    sizePopup.classList.remove('open');
  });
}